import React from 'react';

import ContactButtonsPanel from './ContactButtonsPanel';
import EmailMeForm from './EmailMeForm';
import NomadMap from '../nomadMap/NomadMap';
import { PageContainer, TopSection } from './ContactMe.styles';

function ContactMe() {
  return (
    <PageContainer spacing={4}>
      <TopSection>
        <EmailMeForm />
        <ContactButtonsPanel />
        <NomadMap />
      </TopSection>
    </PageContainer>
  );
}

export default ContactMe;
